const formations = [
  {
    id: 1,
    title: "Master Développeur Full-Stack",
    complement: "Bac+5",
    school: "ECV Digital",
    date: "2023 - 2025",
    lieu: "Lille",
    description:
      "Formation spécialisée en développement web full-stack, architecture logicielle et gestion de projets digitaux. Diplôme obtenu avec succès.",
    status: "Diplômé",
  },
  {
    id: 2,
    title: "Bachelor Développement Web",
    complement: "Bac+3",
    school: "Normandie Web School",
    date: "2022 - 2023",
    lieu: "Rouen",
    description:
      "Formation complète en développement web, technologies front-end et back-end, méthodologies agiles.",
  },
  {
    id: 3,
    title: "Licence 2 Informatique",
    complement: "Bac+2",
    school: "Université de Rouen",
    date: "2021 - 2022",
    lieu: "Rouen",
    description:
      "Fondamentaux de l'informatique, algorithmique, programmation orientée objet, bases de données.",
  },
  {
    id: 4,
    title: "Licence 1 IEEEA",
    complement: "Bac+1",
    school: "Université de Rouen",
    date: "2020 - 2021",
    lieu: "Rouen",
    description:
      "Ingénierie Électrique, Électronique, Énergie électrique et Automatique.",
  },
  {
    id: 5,
    title: "DUT GEII",
    complement: "Bac+2",
    school: "IUT de Rouen",
    date: "2018 - 2020",
    lieu: "Mont-Saint-Aignan",
    description:
      "Diplôme Universitaire de Technologie en Génie Électrique et Informatique Industrielle.",
  },
];

export default formations;
